import React from 'react';
import DetailsBox from '../common/DetailsBox/DetailsBox';
import ListView from '../common/ListView/ListView';

const DvpnnodesCountry = () => {
    return (
        <DetailsBox
            subtitle="Countries"
            subtitlelink="nodes"
            >
                <div className="listing-main-wrapper">
                    <ListView
                        countryflagname="rs"
                        countryname="Russia"
                        counts="45"
                        url="nodelist"
                    />
                    <ListView
                        countryflagname="US"
                        countryname="United States"
                        counts="18"
                        url="nodelist"
                    />
                    <ListView
                        countryflagname="it"
                        countryname="Italy"
                        counts="34"
                        url="nodelist"
                    />
                    <ListView
                        countryflagname="ch"
                        countryname="China"
                        counts="20"
                        url="nodelist"
                    />
                    <ListView
                        countryflagname="cd"
                        countryname="Canada"
                        counts="12"
                        url="nodelist"
                    />
                    <ListView
                        countryflagname="ch"
                        countryname="Chile"
                        counts="10"
                        url="nodelist"
                    />
                    <ListView
                        countryflagname="co"
                        countryname="Colombia"
                        counts="08"
                        url="nodelist"
                    />
                    <ListView
                        countryflagname="co"
                        countryname="France"
                        counts="06"
                        url="nodelist"
                    />
                </div>
        </DetailsBox>
    )
}

export default DvpnnodesCountry
